import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { OrderScanResponse, ResourceSuggestion, ResourceInput } from '../api/scan-types'

export interface ScanState {
  scannedOrder: OrderScanResponse | null
  suggestions: ResourceSuggestion[]
  isScanning: boolean
  isSuggesting: boolean
  error: string | null
  scanSuccess: boolean
  isAssigningResource: boolean
  assignSuccess: boolean
}

const initialState: ScanState = {
  scannedOrder: null,
  suggestions: [],
  isScanning: false,
  isSuggesting: false,
  error: null,
  scanSuccess: false,
  isAssigningResource: false,
  assignSuccess: false,
}

export const scanSlice = createSlice({
  name: 'shipments/scan',
  initialState,
  reducers: {
    // Scan Order
    scanOrder: (state, _action: PayloadAction<string>) => {
      state.isScanning = true
      state.error = null
      state.scanSuccess = false
      state.scannedOrder = null // Clear previous
    },
    scanOrderSuccess: (state, action: PayloadAction<OrderScanResponse>) => {
      state.scannedOrder = action.payload
      state.isScanning = false
      state.scanSuccess = true
      state.error = null
    },
    scanOrderFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.isScanning = false
      state.scanSuccess = false
    },
    resetScan: (state) => {
      state.scannedOrder = null
      state.error = null
      state.scanSuccess = false
      state.isAssigningResource = false
      state.assignSuccess = false
      state.suggestions = []
    },

    // Resource Suggestions
    fetchSuggestions: (state, _action: PayloadAction<{ orderNumber: string; licensePlate?: string; driverPhone?: string }>) => {
      state.isSuggesting = true
    },
    fetchSuggestionsSuccess: (state, action: PayloadAction<ResourceSuggestion[]>) => {
      state.suggestions = action.payload
      state.isSuggesting = false
    },
    fetchSuggestionsFailure: (state) => {
      state.suggestions = []
      state.isSuggesting = false
    },
    clearSuggestions: (state) => {
      state.suggestions = []
    },

    // Assign Resource
    assignResource: (state, _action: PayloadAction<{ orderNumber: string; resource: ResourceInput }>) => {
      state.isAssigningResource = true
      state.error = null
      state.assignSuccess = false
    },
    assignResourceSuccess: (state) => {
      state.isAssigningResource = false
      state.assignSuccess = true
    },
    assignResourceFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.isAssigningResource = false
      state.assignSuccess = false
    },
  },
})

export const scanActions = scanSlice.actions
export const scanReducer = scanSlice.reducer
